module.exports = __webpack_public_path__ + "img/71.3d34cee4.jpg";